import { Component } from "@angular/core";
import { RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import { MatIconModule } from "@angular/material/icon";
import { TranslateDirective } from "@ngx-translate/core";

/**
 * The CRM area shell: a header and a top-level tab bar over a `<router-outlet>`. Its tabs are the CRM
 * areas - "Leads" today (which brings its own Liste / Pipeline sub-tabs via {@link LeadsShell}),
 * Mitglieder later. The lead profile is a separate detail route (`/crm/lead/:id`) without the tabs.
 */
@Component({
    selector: 'crm-shell',
    templateUrl: './crm-shell.html',
    styleUrl: './crm-shell.sass',
    imports: [RouterOutlet, RouterLink, RouterLinkActive, MatIconModule, TranslateDirective],
})
export class CrmShell {}
